import { isBrowser } from '@tbitop/ssr';
import { defaultTo, values } from 'lodash-es';
import log, { LogLevelDesc } from 'loglevel';
import { LogLevel } from './log-level';
import { logToStorage } from './loglevel-local-storage';
import { ModuleLogger } from './module-logger';

export class AppLogger {
  private static instance: AppLogger;

  private constructor(private rootPrefix?: string) { }

  private static toLogLevelDesc(logLevel: LogLevel): LogLevelDesc {
    const mapping = {
      [LogLevel.TRACE]: 0,
      [LogLevel.DEBUG]: 1,
      [LogLevel.INFO]: 2,
      [LogLevel.WARN]: 3,
      [LogLevel.ERROR]: 4,
    } as const;

    return defaultTo(mapping[logLevel], mapping[LogLevel.WARN]);
  }

  public static initialize(minimumLogLevel: LogLevel, prefix?: string): void {
    if (this.instance) {
      console.warn('Logger already initialized. This method has only an effect on the first call.');
      return;
    }

    if (isBrowser) {
      logToStorage(log, {});
    }

    this.setLogLevel(minimumLogLevel);

    this.instance = new AppLogger(prefix);
  }

  public static getModuleLogger(moduleName: string): ModuleLogger {
    if (!this.instance) {
      throw new Error('Initialize logger first by calling "initialize()"');
    }

    if (moduleName === '') {
      throw new Error('moduleName must not be empty.');
    }

    const prefix = this.instance.rootPrefix ? `[${this.instance.rootPrefix}] [${moduleName}]` : `[${moduleName}]`;
    return new ModuleLogger(log.getLogger(moduleName), prefix);
  }

  public static setLogLevel(logLevel: LogLevel) {
    const level = AppLogger.toLogLevelDesc(logLevel);
    log.setLevel(level);
    values(log.getLoggers()).forEach(logger => logger.setLevel(level));
  }
}
